// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e3ab77a5","703":"6a679681","787":"acb79df8"}[chunkId] + ".chunk.js";
};